module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-fr.6b0088fc.svg";